import React, { forwardRef } from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { BtnV2, l } from '@manychat/manyui'

import { AiAlwaysOnAutomationsSelectors } from 'apps/aiAutomation/store/core'
import {
  InstantAnswersPlaygroundActions,
  InstantAnswersPlaygroundSelectors,
} from 'apps/aiAutomation/store/instantAnswersPlayground'
import { ConversationEndReason } from 'apps/aiAutomation/store/instantAnswersPlayground/types'
import { useAssigneeOptions } from 'common/settings/components/BotAssigneePicker/useAssigneeOptions'

import cm from './ConversationFinishedControls.module.css'

export const ConversationFinishedControls = forwardRef<HTMLLIElement>((_, ref) => {
  const dispatch = useAppDispatch()

  const conversationEndReason = useAppSelector(
    InstantAnswersPlaygroundSelectors.getConversationEndReason,
  )
  const fallbackAssignee = useAppSelector(AiAlwaysOnAutomationsSelectors.getFallbackAssignee)

  const { selectedOptionValue: selectedAssigneeOption } = useAssigneeOptions(
    fallbackAssignee ?? undefined,
  )

  return (
    <li className={cm.conversationFinishedControls} ref={ref}>
      <p className="m-b">
        {conversationEndReason === ConversationEndReason.SUCCESS &&
          l.translate('Want to take another look?')}

        {conversationEndReason === ConversationEndReason.NOT_RECOGNIZED &&
          l.translate('Restart preview to ask a new question.')}

        {conversationEndReason === ConversationEndReason.OPERATOR_REQUESTED &&
          selectedAssigneeOption &&
          l.translate('AI would assign to {personOrGroupName} instead.', {
            personOrGroupName: selectedAssigneeOption.label,
          })}

        {conversationEndReason === ConversationEndReason.OPERATOR_REQUESTED &&
          !selectedAssigneeOption &&
          l.translate('Add relevant info for AI to reply on this topic.')}
      </p>

      <BtnV2
        onClick={() => dispatch(InstantAnswersPlaygroundActions.sessionReset())}
        label={l.translate('Restart preview')}
        leftIcon="Retry"
      />
    </li>
  )
})
